module.exports = __webpack_public_path__ + "static/media/correct-effect.78142c30.mp3";